import React from "react";

import { useSidebar } from "./hooks/useSidebar";

interface SidebarGroupProps {
  className?: string;
  children: React.ReactNode;
}

/**
 * SidebarGroup - Container for a group of related navigation items
 *
 * @param className - Additional CSS classes
 * @param children - Group content (typically SidebarMenu)
 */
export function SidebarGroup({ className = "", children }: SidebarGroupProps) {
  const { state } = useSidebar();

  return (
    <div
      className={`
        flex flex-col gap-2xs
        ${className}
      `.trim()}
      data-state={state}
    >
      {children}
    </div>
  );
}
